module.exports = __webpack_public_path__ + "static/simplex-example-5711ebb8295ed45201b129a45224030c.png";